import { Link } from 'react-router-dom'

function Footer() {
    return (
        <footer className="main-footer section-space-top">
            <div className="container">
                <div className="main-footer__top">
                    <Link to="/" className="main-footer__logo">
                        <img src="/assets/images/logo-dark.png" width="209" alt="Rivojlan.uz" />
                    </Link>
                    <div className="main-footer__top__inner">
                        <div className="main-footer__newsletter">
                            <form action="#" data-url="MAILCHIMP_FORM_URL"
                                className="main-footer__newsletter__form mc-form">
                                <input type="text" name="EMAIL" placeholder="Elektron pochtangizni kiriting" />
                                <button type="submit" className="eduhive-btn">
                                    <span>Jo'natish</span>
                                </button>
                            </form>
                            <div className="mc-form__response"></div>
                        </div>
                        <div className="main-footer__social social-links">
                            <a href="https://facebook.com">
                                <i className="fab fa-facebook-f" aria-hidden="true"></i>
                                <span className="sr-only">Facebook</span>
                            </a>
                            <a href="https://t.me">
                                <i className="fab fa-telegram-plane" aria-hidden="true"></i>
                                <span className="sr-only">Telegram</span>
                            </a>
                            <a href="https://instagram.com">
                                <i className="fab fa-instagram" aria-hidden="true"></i>
                                <span className="sr-only">Instagram</span>
                            </a>
                            <a href="https://youtube.com">
                                <i className="fab fa-youtube" aria-hidden="true"></i>
                                <span className="sr-only">Youtube</span>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="row gutter-y-40">
                    <div className="col-xl-3 col-lg-4 wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="00ms">
                        <div className="footer-widget footer-widget--about">
                            <h2 className="footer-widget__title">Rivojlan.uz</h2>
                            <p className="footer-widget__about-text">
                                Bo'lajak tarbiyachilarni kasbiy metodik kompetensiyalarini rivojlantirish
                                texnologiyasi.
                            </p>
                            <ul className="footer-widget__info">
                                <li>
                                    <span className="footer-widget__info__icon"><i className="icon-email"></i></span>
                                    <a href="mailto:info@rivojlan.uz">info@rivojlan.uz</a>
                                </li>
                                <li>
                                    <span className="footer-widget__info__icon"><i className="icon-telephone"></i></span>
                                    <a href="tel:+998933763383">+998933763383</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-4 col-sm-6 wow fadeInUp" data-wow-duration="1500ms"
                        data-wow-delay="100ms">
                        <div className="footer-widget footer-widget--links">
                            <h2 className="footer-widget__title">Havolalar</h2>
                            <ul className="list-unstyled footer-widget__links">
                                <li>
                                    <Link to="/">
                                        <span className="footer-widget__links__icon">
                                            <i className="icon-double-arrow"></i>
                                        </span>
                                        Bosh sahifa
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/experiments">
                                        <span className="footer-widget__links__icon">
                                            <i className="icon-double-arrow"></i>
                                        </span>
                                        Xorijiy tajribalar
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/methods">
                                        <span className="footer-widget__links__icon">
                                            <i className="icon-double-arrow"></i>
                                        </span>
                                        Metodlar
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-xl-6 col-md-8 wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="300ms">
                        <div className="footer-widget footer-widget--gallery">
                            <h2 className="footer-widget__title">O'rganish</h2>
                            <div className="footer-widget__gallery">
                                <Link to="/experiment/germany" className="footer-widget__gallery__link">
                                    <img src="/assets/images/germany_flag.png" alt="footer-widget-gallery" />
                                    <span className="footer-widget__gallery__icon">
                                        <i className="fas fa-angle-double-up"></i>
                                    </span>
                                </Link>
                                <Link to="/experiment/korea" className="footer-widget__gallery__link">
                                    <img src="/assets/images/korea_flag.png" alt="footer-widget-gallery" />
                                    <span className="footer-widget__gallery__icon">
                                        <i className="fas fa-angle-double-up"></i>
                                    </span>
                                </Link>
                                <Link to="/experiments/russia" className="footer-widget__gallery__link">
                                    <img src="/assets/images/russia_flag.jpg" alt="footer-widget-gallery" />
                                    <span className="footer-widget__gallery__icon">
                                        <i className="fas fa-angle-double-up"></i>
                                    </span>
                                </Link>
                                <Link to="/experiment/usa" className="footer-widget__gallery__link">
                                    <img src="/assets/images/usa_flag.png" alt="footer-widget-gallery" />
                                    <span className="footer-widget__gallery__icon">
                                        <i className="fas fa-angle-double-up"></i>
                                    </span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="main-footer__bottom">
                <div className="container">
                    <div className="main-footer__bottom__inner">
                        <p className="main-footer__copyright">
                            ©Rivojlan.uz - <span className="dynamic-year">{new Date().getFullYear()}</span>
                        </p>
                    </div>
                </div>
            </div>
            <img src="/assets/images/footer-shape-1.png" alt="shape" className="main-footer__shape-one" />
            <img src="/assets/images/footer-shape-2.png" alt="shape" className="main-footer__shape-two" />
            <img src="/assets/images/footer-shape-3.png" alt="shape" className="main-footer__shape-three" />
            <img src="/assets/images/footer-shape-4.png" alt="shape" className="main-footer__shape-four" />
            <img src="/assets/images/footer-shape-5.png" alt="shape" className="main-footer__shape-five" />
        </footer>
    )
}

export default Footer